import type { TFunction } from 'i18next';

export const criticalityOptions = (t: TFunction) => [
  { key: t('Low'), value: 'low' },
  { key: t('Medium'), value: 'medium' },
  { key: t('High'), value: 'high' },
];
